export const pluralize = (
  count: number | null,
  singular: string,
  plural: string
) => (Number(count) === 1 ? `${count} ${singular}` : `${count} ${plural}`);
